import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { ErrorLogFilters, ErrorLogPage } from '../types/error-log'

export async function getErrorLogs(filters: ErrorLogFilters): Promise<ErrorLogPage> {
  const params = new URLSearchParams()
  params.set('page', String(filters.page))
  params.set('size', String(filters.size))

  if (filters.httpStatus) params.set('httpStatus', String(filters.httpStatus))
  if (filters.search) params.set('search', filters.search)
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)

  const response = await api.get<ApiResponse<ErrorLogPage>>(`/api/error-logs?${params}`)
  return response.data.data
}
